import {
  actionLoading,
  actionSuccess,
  actionErrored,
  actionReset,
} from 'api/helpers';
import { unAuthRequest, authRequest } from 'api/helpers';
import URL, { getDynamicEndpoint } from '../../api/endpoints';

// Login user API action
export const LOGIN_USER = 'LOGIN_USER';

export const loadingLoginUser = actionLoading(LOGIN_USER);
export const successLoginUser = actionSuccess(LOGIN_USER);
export const erroredLoginUser = actionErrored(LOGIN_USER);

export const loginUser = (data) => {
  return (dispatch) =>
    unAuthRequest.post(
      dispatch,
      data,
      URL.token,
      loadingLoginUser,
      successLoginUser,
      erroredLoginUser
    );
};

// Resets state data for login user
export const resetLoginUserState = (cb) => {
  return function (dispatch) {
    dispatch({
      type: LOGIN_USER,
    });
    cb();
  };
};

// Fetch user profile API action
export const FETCH_USER_PROFILE = 'FETCH_USER_PROFILE';

export const loadingFetchUserProfile = actionLoading(FETCH_USER_PROFILE);
export const successFetchUserProfile = actionSuccess(FETCH_USER_PROFILE);
export const erroredFetchUserProfile = actionErrored(FETCH_USER_PROFILE);

export const fetchUserProfile = () => {
  return (dispatch) =>
    authRequest.get(
      dispatch,
      URL.profile,
      loadingFetchUserProfile,
      successFetchUserProfile,
      erroredFetchUserProfile
    );
};

// update user profile
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';

export const updateUserProfileLoading = actionLoading(UPDATE_USER_PROFILE);
export const updateUserProfileSuccess = actionSuccess(UPDATE_USER_PROFILE);
export const updateUserProfileErrored = actionErrored(UPDATE_USER_PROFILE);
export const updateUserProfileReset = actionReset(UPDATE_USER_PROFILE);

export const updateUserProfile = (data) => {
  return (dispatch) =>
    authRequest.post(
      dispatch,
      data,
      getDynamicEndpoint().update_user_profile,
      updateUserProfileLoading,
      updateUserProfileSuccess,
      updateUserProfileErrored
    );
};

export const resetUpdateUserProfileState = () => {
  return function (dispatch) {
    dispatch(updateUserProfileReset());
  };
};

// Fetch user profile API action
export const FETCH_USER_COLLECTIONS = 'FETCH_USER_COLLECTIONS';

export const loadingFetchUserCollections = actionLoading(
  FETCH_USER_COLLECTIONS
);
export const successFetchUserCollections = actionSuccess(
  FETCH_USER_COLLECTIONS
);
export const erroredFetchUserCollections = actionErrored(
  FETCH_USER_COLLECTIONS
);

export const fetchUserCollections = () => {
  return (dispatch) =>
    authRequest.get(
      dispatch,
      getDynamicEndpoint().user_collections,
      loadingFetchUserCollections,
      successFetchUserCollections,
      erroredFetchUserCollections
    );
};

/* Generate user's API token */
export const GENERATE_USER_API_TOKEN = 'GENERATE_USER_API_TOKEN';

export const generateUserAPITokenLoading = actionLoading(
  GENERATE_USER_API_TOKEN
);
export const generateUserAPITokenSuccess = actionSuccess(
  GENERATE_USER_API_TOKEN
);
export const generateUserAPITokenErrored = actionErrored(
  GENERATE_USER_API_TOKEN
);
export const generateUserAPITokenReset = actionReset(GENERATE_USER_API_TOKEN);

export const generateUserAPIToken = (data) => {
  return (dispatch) =>
    authRequest.post(
      dispatch,
      null,
      getDynamicEndpoint().generate_api_token,
      generateUserAPITokenLoading,
      generateUserAPITokenSuccess,
      generateUserAPITokenErrored
    );
};

export const resetGenerateAPITokenState = () => {
  return function (dispatch) {
    dispatch(generateUserAPITokenReset());
  };
};

// API for delete access key token
export const DELETE_USER_API_TOKEN = 'DELETE_USER_API_TOKEN';

export const deletUserAPITokenLoading = actionLoading(DELETE_USER_API_TOKEN);
export const deletUserAPITokenSuccess = actionSuccess(DELETE_USER_API_TOKEN);
export const deletUserAPITokenErrored = actionErrored(DELETE_USER_API_TOKEN);
export const deletUserAPITokenReset = actionReset(DELETE_USER_API_TOKEN);

export const deleteUserAPIToken = (accessKey) => {
  return (dispatch) =>
    authRequest.delete(
      dispatch,
      getDynamicEndpoint().delete_api_token + `/${accessKey}`,
      deletUserAPITokenLoading,
      deletUserAPITokenSuccess,
      deletUserAPITokenErrored
    );
};

export const resetDeleteUserAPITokenState = () => {
  return function (dispatch) {
    dispatch(deletUserAPITokenReset());
  };
};
